import Api from "shared/service/api/api";

export const LOAD_USER_PARTNERS = "loadUserPartners";
export const LOAD_USER_AS_PARTNER = "loadUserAsPartner";
export const LOAD_CATALOG_LINK = "loadCatalogLink";

export const SET_USER_PARTNERS = "setUserPartners";
export const SET_USER_AS_PARTNER = "setUserAsPartner";
export const SET_CATALOG_LINK = "setCatalogLink";

const state = {
  userPartners: {
    byItem: [],
    byPartner: [],
    total: null,
  },
  userAsPartner: {
    list: [],
    total: null,
  },
  partnerCatalogLink: "",
};

const actions = {
  [LOAD_USER_PARTNERS]({ commit }, { date_from = "", date_to = "" }) {
    return Api.collaboration.partner
      .all(date_from, date_to)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_USER_PARTNERS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_USER_AS_PARTNER]({ commit }, { date_from = "", date_to = "" }) {
    return Api.collaboration.partner
      .selfData(date_from, date_to)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_USER_AS_PARTNER, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_CATALOG_LINK]({ commit }, projectId) {
    return Api.collaboration.partner
      .catalogLink(projectId)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_CATALOG_LINK, response.data.link);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_USER_PARTNERS](state, data) {
    state.userPartners.byItem = data?.by_item || [];
    state.userPartners.byPartner = data?.by_partner || [];
    state.userPartners.total = data?.total || null;
  },
  [SET_USER_AS_PARTNER](state, { list, total }) {
    state.userAsPartner.list = list;
    state.userAsPartner.total = total;
  },
  [SET_CATALOG_LINK](state, catalogLink) {
    state.partnerCatalogLink = catalogLink;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
